module.exports = __webpack_public_path__ + "img/eprf-calendar.9ac8593f.png";